<template>
  <img
    v-if="team?.logo_url"
    :src="team.logo_url"
    class="inline-block object-contain object-center mr-2"
    :class="{
      'w-5 h-5 md:w-8 md:h-8': size === 'tiny',
      'w-10 h-10': size === 'md',
      'w-12 h-12': size === 'lg',
      'w-16 h-16': size === 'xl',
    }"
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    team?: {
      logo_url?: string;
    };
    size?: 'tiny' | 'sm' | 'md' | 'lg' | 'xl';
  }>(),
  {
    size: 'tiny',
  }
);
</script>
